var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47884 3.05383e-06C7.89305 -0.00116636 8.22978 0.333671 8.23095 0.747884L8.26906 14.2479C8.27023 14.6621 7.93539 14.9988 7.52118 15C7.10697 15.0012 6.77024 14.6663 6.76907 14.2521L6.73096 0.752118C6.72979 0.337906 7.06463 0.00117247 7.47884 3.05383e-06Z",
    fill: "#58486C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.51097C14.9994 7.92519 14.6631 8.26049 14.2489 8.25988L0.748907 8.24024C0.334695 8.23963 -0.000601779 7.90336 8.10952e-07 7.48914C0.000604001 7.07493 0.336878 6.73963 0.751091 6.74024L14.2511 6.75988C14.6653 6.76049 15.0006 7.09676 15 7.51097Z",
    fill: "#58486C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.80bf8df28ee614fdd83cb8ea6e4f82b8.svg";
export { ForwardRef as ReactComponent };